import { jsx } from "react/jsx-runtime";
import HmimhwPropertySearch from "@zillow/hmimhw-property-search";
import PropTypes from "prop-types";
import "react";
import styled from "styled-components";
const HmimhwPropertySearchWrapper = /* @__PURE__ */ styled.div.withConfig({
  displayName: "HmimhwPropertySearch__HmimhwPropertySearchWrapper",
  componentId: "sc-1lzwlpq-0"
})(["max-width:100%;width:720px;"]);
const PUBLIC_CONFIG_VALUES_MAP = {
  test: {
    addressAutocompleteURL: "https://static.qa.zillow.net/autocomplete/v3/suggestions/",
    gdpServiceUrl: "https://www.qa.zillow.net/graphql/",
    zatlasEndpoint: "https://proxy.dev.zillow.net/develop/"
  },
  prod: {
    addressAutocompleteURL: "https://www.zillowstatic.com/autocomplete/v3/suggestions/",
    gdpServiceUrl: "https://www.zillow.com/graphql/",
    zatlasEndpoint: "https://proxy.zillowapi.com/prod/"
  }
};
const BlockHmimhwPropertySearch = ({
  attrs,
  index
}) => {
  const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /* @__PURE__ */ jsx(HmimhwPropertySearchWrapper, { children: /* @__PURE__ */ jsx(HmimhwPropertySearch, { publicConfigValues: PUBLIC_CONFIG_VALUES_MAP[NEXT_PUBLIC_ENV] || PUBLIC_CONFIG_VALUES_MAP.test, isLightboxBackgroundLocked: false, ...attrs }, index) });
};
BlockHmimhwPropertySearch.propTypes = {
  attrs: PropTypes.shape({
    placementId: PropTypes.string,
    surfaceId: PropTypes.string,
    xConsumerUsername: PropTypes.string
  }),
  index: PropTypes.number
};
export {
  BlockHmimhwPropertySearch as default
};
